import React from 'react';
import PropTypes from 'prop-types';
import SweetAlert from 'react-bootstrap-sweetalert';

import { BasicInput } from '../../../common/basic-input';
import { SecondaryButton } from '../../../common/secondary-button';
import { RecaptchaComponent } from '../../../common/recaptcha-component';

import styles from './DataForm.css';
import { PasswordRecoveryController } from '../../../networking/controllers/PasswordRecoveryController';
import { AppLink, routeNaming } from '../../../routes';
import { Recaptcha } from '../../../helpers/Recaptcha';

const IPropTypes = {
  className: PropTypes.string,
};

const defaultProps = {
  className: '',
};

class DataForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userId: null,
      emailSent: false,
      internalError: false,
      error: null,
      recaptchaToken: null,
      recaptchaError: null,
      promptSuccess: false,
      messageSuccess: '',
    };

    this._onSubmit = this._onSubmit.bind(this);
    this._updateUserId = this._updateUserId.bind(this);
    this._onRecaptchaError = this._onRecaptchaError.bind(this);
    this._onRecaptchaExpiry = this._onRecaptchaExpiry.bind(this);
    this._onRecaptchaSuccess = this._onRecaptchaSuccess.bind(this);
    this._closeModal = this._closeModal.bind(this);
  }

  _updateUserId(event) {
    const { target: { value } } = event;
    this.setState({
      userId: value,
    });
  }

  _onRecaptchaSuccess(token) {
    this.setState({
      recaptchaError: false,
      recaptchaToken: token,
    });
  }

  _onRecaptchaError() {
    this.setState({
      recaptchaError: true,
    });
  }

  _onRecaptchaExpiry() {
    this.setState({
      recaptchaToken: null,
    });
  }

  _closeModal() {
    this.setState({
      promptSuccess: false,
    });
  }

  _dataIsValid() {
    return this.state.userId && this.state.recaptchaToken;
  }

  async _onSubmit(event) {
    event.preventDefault();
    if (this._dataIsValid()) {
      PasswordRecoveryController.forgotPassword(
        this.state.userId,
        this.state.recaptchaToken,
      ).then((res) => {
        this.setState({
          emailSent: true,
          error: null,
          recaptchaToken: null,
          internalError: false,
          promptSuccess: true,
          messageSuccess: `En los próximos minutos recibirás un e-mail a la dirección de correo ${res.data}.`,
        });
        Recaptcha.reset();
      }).catch((error) => {
        Recaptcha.reset();
        if (error && error.status === 500) {
          this.setState({
            internalError: true,
            error: null,
            emailSent: false,
            recaptchaToken: null,
          });
        } else {
          this.setState({
            emailSent: false,
            error: error.message,
            recaptchaToken: null,
            internalError: false,
          });
        }
      });
    }
  }

  render() {
    return (
      <form
        className={this.props.className}
        onSubmit={this._onSubmit}
      >
        <BasicInput
          className={styles.input}
          label="Email / Documento / RUT"
          name="userId"
          onChange={this._updateUserId}
        />
        <div className={styles.recaptcha}>
          {
            !!this.state.recaptchaError &&
            <p className={styles.errorMessage}>
              Ha ocurrido un error, intente realizar el reCAPTCHA de nuevo.
            </p>
          }
          <RecaptchaComponent
            onError={this._onRecaptchaError}
            onExpiry={this._onRecaptchaExpiry}
            onSuccess={this._onRecaptchaSuccess}
          />
        </div>
        <SecondaryButton
          className={styles.button}
          type="submit"
          disabled={!this._dataIsValid() || this.state.emailSent}
        >
          RECUPERAR
        </SecondaryButton>
        {this.state.internalError &&
          <p className={styles.errorMessage}>
            Estamos experimentando algunas dificultades en nuestro sitio.
            Por favor intente nuevamente en unos momentos.
          </p>}
        {this.state.error &&
          <p className={styles.errorMessage} style={{ textAlign: 'center', marginBottom: 10 }}>
            {this.state.error}
          </p>}
        <AppLink
          className={styles.recoverAccountLink}
          routeName={routeNaming.RECOVER_ACCOUNT}
        >
          No tengo acceso a mi dirección de correo electrónico
        </AppLink>
        {
          this.state.promptSuccess &&
          <SweetAlert
            title="Recuperar contraseña"
            confirmBtnText="Aceptar"
            confirmBtnCssClass={`${styles.btnAccept} ${styles.btn}`}
            onConfirm={this._closeModal}
            closeOnClickOutside={false}
            style={{
              width: '100%',
              left: 0,
              right: 0,
              maxWidth: '500px',
              margin: '0 auto',
              top: '30%',
            }}
          >
            <p>{this.state.messageSuccess}</p>
          </SweetAlert>
        }
      </form>
    );
  }
}

DataForm.propTypes = IPropTypes;
DataForm.defaultProps = defaultProps;

export { DataForm };



// WEBPACK FOOTER //
// ./src/pages/forgot-password/data-form/DataForm.jsx